import { useEffect, useRef, useState } from "react";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";

import api from "../../services/api";
import toastError from "../../errors/toastError";
import { i18n } from "../../translate/i18n";
import { telefoneParaConversar } from "../../helpers/vcard";

// "Conversar" de um contato compartilhado: abre (ou reaproveita) a conversa pelo fluxo de
// Novo lead. `carregando` guarda os dígitos de quem está sendo aberto, para a lista do modal
// travar só o botão clicado.
const useConversarContato = (whatsappId) => {
  const history = useHistory();
  const [carregando, setCarregando] = useState(null);
  /// abrir a conversa troca de tela e desmonta quem chamou ///
  const montado = useRef(true);
  useEffect(() => () => { montado.current = false; }, []);

  const podeConversar = (contato) =>
    !!telefoneParaConversar(contato) && !!whatsappId && !carregando;

  const conversar = async (contato, aoAbrir) => {
    const telefone = telefoneParaConversar(contato);
    if (!telefone || !whatsappId || carregando) return;
    setCarregando(telefone.digitos);
    try {
      const { data } = await api.post("/ticketsNovoLead", {
        name: contato.nome || telefone.numero,
        number: telefone.digitos,
        whatsappId,
      });
      if (data.isExisting) {
        toast.info(i18n.t("newTicketModal.infoExisting"));
      } else {
        toast.success(i18n.t("newTicketModal.successNew"));
      }
      if (aoAbrir) aoAbrir();
      history.push(`/tickets/${data.ticket.id}`);
    } catch (err) {
      toastError(err);
    }
    if (montado.current) setCarregando(null);
  };

  return { conversar, podeConversar, carregando };
};

export default useConversarContato;
